export const LEAVE_APPLICATION_NAME = 'Заява на відпустку';
export const ORDER_NAME_SUFFIX = '_View';
